import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import * as Sentry from "@sentry/react";
import { shouldInitSentry } from "./utils/sentryConfig";
import { scrubSentryEvent } from "./utils/sentryScrubber";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      refetchOnWindowFocus: false,
      retry: 2,
    },
  },
});

if (shouldInitSentry) {
  Sentry.init({
    dsn: "https://3981980e54b58c6fd1a9cf1dd8b71ec4@o4509197123059712.ingest.us.sentry.io/4509197129678848",
    environment: process.env.REACT_APP_SENTRY_ENV || process.env.NODE_ENV,
    sendDefaultPii: false,
    beforeSend: scrubSentryEvent,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: ["https://app.123wellness.org"],
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 0.2,
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Capture web vitals for analytics (flushed after user is known)
reportWebVitals((metric) => {
  window.__webVitals = window.__webVitals || [];
  window.__webVitals.push(metric);
});
